import store, { MODULES_PATHS } from '@/store';
import { ACTION_TYPES as WORKATO_CONFIGURATION_ACTION_TYPES } from '@/store/modules/data/workato-configuration/actions';
import { GETTER_TYPES as WORKATO_CONFIGURATION_GETTER_TYPES } from '@/store/modules/data/workato-configuration/getters';

const getWorkatoRouteName = (token, isAdminUser) => {
  if (token) {
    return 'workato-integration';
  } else if (isAdminUser) {
    return 'workato-activation';
  }
  return 'workato-nonadmin';
};

const workflowGuard = {
  async beforeRouteEnter(to, from, next) {
    const wokflowNames = ['workflows', 'workato-integration', 'workato-activation', 'workato-nonadmin'];
    if (wokflowNames.includes(to.name)) {
      try {
        await store.dispatch(`${MODULES_PATHS.DATA.WORKATO_SITE_SETTINGS}/${WORKATO_CONFIGURATION_ACTION_TYPES.FETCH_WORKATO_TOKEN}`);
        const isLpa = store.getters['session/getConfig']().isLPA;
        const isAdmin = store.getters['session/getConfig']().isAdmin;
        const wToken = store.getters[`${MODULES_PATHS.DATA.WORKATO_SITE_SETTINGS}/${WORKATO_CONFIGURATION_GETTER_TYPES.GET_WORKATO_TOKEN}`].token;
        const toRouteRedirect = getWorkatoRouteName(wToken, (isLpa || isAdmin));
        if (to.name !== toRouteRedirect) {
          next({ name: toRouteRedirect });
        } else {
          next();
        }
      } catch (error) {
        next(false);
      }
    } else {
      next();
    }
  },
};

export default workflowGuard;
